import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { RegisterService } from "../../components/register/register.service";
import { TranslateService } from "@ngx-translate/core";
import { GUEST, STATUS_CHECKED_IN, STATUS_INVITED, STATUS_REGISTERED, STATUS_UNINVITED } from "../constants/constants";
import { InvitedKindEnum } from "../models";

@Injectable({
  providedIn: "root",
})
export class EventGuard {
  token: string;
  participantToken: string;
  genericErrorTranslated = '';
  isCanActivate = false;

  constructor(
    public router: Router,
    private toastrService: ToastrService,
    private registerService: RegisterService,
    private translateService: TranslateService,
    
  ) { 
    this.genericErrorTranslated = this.translateService.instant(
      "errors.generic_error"
    );
  }

  canActivate(
    state: RouterStateSnapshot,
    route: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const params = route.root.children[0].params;
    this.token = params["token"];
    this.participantToken = params["tokenParticipant"];
    
    if (this.participantToken !== GUEST) {
      
      this.registerService.getEventForParticipants(this.token, this.participantToken).subscribe({
        next: (v) => {
          const status = v.data?.participants?.status ?? "";
          const type = v.data?.participants?.type ?? "";
          console.log('status', status);
          console.log('type', type);
          if (status === STATUS_REGISTERED || status === STATUS_CHECKED_IN) {
            this.router.navigate([
              "/events/" +
              this.token +
              "/participants/" +
              this.participantToken,
            ]);
          } else if (status === STATUS_INVITED || (status === STATUS_UNINVITED && type === InvitedKindEnum.Dealer)) {
            this.router.navigate([
              "/events/" +
              this.token +
              "/participants/" +
              this.participantToken +
              "/register",
            ]);
          }
          this.isCanActivate = true;
        },
      });

    } else {
      this.registerService.getEventForRegisterGuest(this.token).subscribe({
        next: (v) => {
          if (v.success && (v.data?.token ?? '') === this.token) {
            this.router.navigate([
              "/events/" +
              this.token +
              "/participants/" +
              this.participantToken +
              "/register",
            ]);
            this.isCanActivate = true;
          } else {
            throw Error(this.translateService.instant("errors.event_not_found"));
          }
          
        },
        error: (error) => {
          console.error("Error:", error);
          this.toastrService.error(this.genericErrorTranslated, error);
        }
      });
    }
    
    if (!this.isCanActivate) {
      this.router.navigate(['/event-not-found']);
    }  
    return this.isCanActivate;
  }
}
